import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getParam } from '/src/utils/location';
import { AUTH_TOKEN_KEY } from '/src/features/_global/constants';
import { useAuthContext } from '/src/hooks';

export function StripePage() {
  const navigate = useNavigate();
  const { currentAccount } = useAuthContext();
  const isStripeUser = Boolean(currentAccount?.useStripe);
  const token = window.localStorage.getItem(AUTH_TOKEN_KEY);
  const haveType = getParam('type');
  const billingType = haveType ? `&type=${haveType}` : '';

  useEffect(() => {
    if (!isStripeUser) {
      navigate('/checkout', { replace: true });
      return;
    }

    window.location.replace(`${window.CORE_API_URL}/stripe-portal?token=${token}${billingType}`);
  }, [isStripeUser, token, billingType, navigate]);

  return null;
}
